import React, { Component } from 'react'; 
import Telefonos from './Telefonos';
import Email from './Email';
import Confirmador from './Confirmador';
import DireccionExistente from './DireccionExistente';
import DomicilioExistente from './DomicilioExistente';
import ErrorGuardadoGlobal from './ErrorGuardadoGlobal';
import Domicilio from './Domicilio';

class ModalContenedor extends Component {
    constructor(props) {
        super(props);
    }
    render() { 
        const {medio, data, actions, domiciliosCombos} = this.props;

        let componente;
        let modalContainerCss = 'modalContainer';

        switch(medio){

            case 'MODIFICACION-3':
            case 'MODIFICACION-4':
            case 'TELEFONICO':{
                componente = <Telefonos
                esModificacion ={data.modalAbierto == 'MODIFICACION-3' || data.modalAbierto == 'MODIFICACION-4'} 
                data={data} 
                funcionAceptar={actions.validarEdicionLocalizacion} 
                funcionModificarCheck={actions.selectCheck} 
                funcionModalConfirmador={actions.modalConfirmador} 
                funcionEdicion={actions.editarCampoLocalizacion} 
                />
                break;
            }

            case 'MODIFICACION-2':
            case 'EMAIL':{
                componente = <Email
                esModificacion ={data.modalAbierto == 'MODIFICACION-2'} 
                data={data} 
                funcionAceptar={actions.validarEdicionLocalizacion} 
                funcionModificarCheck={actions.selectCheck} 
                funcionModalConfirmador={actions.modalConfirmador} 
                funcionEdicion={actions.editarCampoLocalizacion} 
                />
                break;
            }
            case 'DIRECCIONEXISTENTE-MODIFICACION':
            case 'DIRECCIONEXISTENTE':{
                componente = <DireccionExistente
                data={data} 
                funcionAceptar={actions.guardarMedioLocalizacion}  
                funcionCancelar={actions.abrirModalLocalizacion} 
                />
                break;
            }

            case 'CONFIRMADOR':{
                componente = <Confirmador 
                data={data} 
                funcionModalConfirmador={actions.modalConfirmador}
                mensaje={"¿Está seguro de que desea abortar la operación?"}
                />
                break;
            }
            
            case 'ELIMINAR':
            case 'ELIMINAR':
            case 'ELIMINAR':{
                
                let tipoMedio = data.mediosLocalizacionEliminar[0] ? data.mediosLocalizacionEliminar[0].TipoComunicacionId : 0;
                let mensaje = "¿Está seguro de que desea eliminar la dirección electrónica?"; 

                if(tipoMedio == 1) mensaje = "¿Está seguro de que desea eliminar el domicilio?"
                if(tipoMedio == 3 || tipoMedio == 4) mensaje = "¿Está seguro de que desea eliminar el teléfono?"

                componente = <Confirmador 
                data={data}
                elimina={true}//flag para que no se abra ningún modal al tocar el botón cancelar 
                funcionModalConfirmador={actions.modalConfirmador}
                mensaje={mensaje} 
                />
                break;
            }
            case 'MODIFICACION-1':
            case 'POSTAL':{
                modalContainerCss ='modalContainer modalDomicilio';
                componente = <Domicilio
                esModificacion = {data.modalAbierto == 'MODIFICACION-1'}
                data={data} 
                domiciliosCombos={domiciliosCombos}
                funcionModalConfirmador={actions.modalConfirmador}
                seleccionarCombo={actions.seleccionarCombo}
                selectCheckDomicilio={actions.selectCheckDomicilio}
                funcionAceptar={actions.validarEdicionLocalizacion} 
                funcionEdicion={actions.editarCampoLocalizacion} 
                funcionCancelar={actions.modalConfirmador} 
                />
                break;
            }

            case 'DOMICILIO_EXISTENTE':{
                componente = <DomicilioExistente
                data={data} 
                domiciliosData={data.domicilioPrevio}
                funcionAceptar={actions.guardarMedioLocalizacion}  
                funcionCancelar={actions.abrirModalLocalizacion} 
                />
                break;
            }

            case 'ADVERTENCIA_DOMICILIO_LEGAL':{
                componente = <ErrorGuardadoGlobal
                mensaje={"No es posible dar de baja este domicilio porque es el domicilio legal declarado para una cuenta activa del cliente.  Debe primero asociar otro domicilio del cliente como nuevo domicilio legal para la cuenta y posteriormente solicitar la baja de este domicilio"} 
                funcionAceptar={actions.aceptarModalInfo}
                />
                break;
            }

            case 'ERROR-GUARDADO-GLOBAL':{
                componente = <ErrorGuardadoGlobal 
                funcionAceptar={actions.aceptarModalInfo}
                />
                break;
            }
        }
        
        return (
            <div className={modalContainerCss}>
                <div className='modalModificacionOut'>
                {componente}
                </div>
            </div>
        )
    }
}
export default ModalContenedor;